import ResponsiveImage from '@/UI/MUI/ResponsiveImage/ResponsiveImage'
import { Grid, Typography, Box } from '@mui/material'
import Image from 'next/image'

const CTOLetter = () => {
  return (
    <Grid container spacing={4} mt={2} mb={6} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
      <Grid item xs={12} md={2}>
        <ResponsiveImage
          aspectRatio="1 / 1"
          objectFit="cover"
          sx={{ maxWidth: '160px', margin: 'auto' }}
          src="https://cdn.zuto.cloud/assets/images/about-zuto/desktop/jim.png"
          alt="James Wilkinson"
        />
      </Grid>
      <Grid item xs={12} md={10}>
        <Typography
          variant="h1"
          component="h1"
          sx={{ fontSize: { xs: '32px', sm: '50px' } }}
          mb={6}
        >
          We promise to make financing a car simple.
        </Typography>
        <Typography variant="bodyLarge" component="p">
          Zuto was founded in 2006 and we set out with a mission to remove the complexity and hassle
          of finding and financing a car.
        </Typography>
        <Typography variant="bodyLarge" component="p">
          We&apos;re passionate about matching people to a finance package that&apos;s right for
          them.
        </Typography>
        <Typography variant="bodyLarge" component="p">
          Our wide range of lender options and fast approval process will find the most suitable
          finance package for our customers from over 275 lender products. Our technology and 5-star
          service has helped over 450,000 people buy the car they want at a price they can afford.
        </Typography>
        <Typography variant="bodyLarge" component="p">
          Whether it&apos;s the first time you&apos;ve financed a car or you&apos;ve done it
          countless times, we&apos;ll take the hassle out of it making sure you get the right car at
          a monthly price that&apos;s right for you.
        </Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap'
          }}
        >
          <Box>
            <Image
              width={150}
              height={81}
              src="https://cdn.zuto.cloud/assets/images/about-zuto/mobile/signature.png"
              alt="Zuto CEO's signature"
            />
            <Typography variant="body2">CEO Zuto</Typography>
          </Box>
          <Image
            width={148}
            height={44}
            src="https://cdn.zuto.cloud/assets/images/homepage/desktop/autotrader-preferred-partner-logo.svg"
            alt="AutoTrader logo"
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export default CTOLetter
